module.exports = __webpack_public_path__ + "img/id-card.095f0b50.svg";